import { memo, type RefObject } from 'react';
import type { Item } from '@scribbleplot/shared';
import { ItemView, isLodItem } from './ItemView';

export type ItemEvents = {
  down: (item: Item, event: React.PointerEvent) => void;
  double: (item: Item, event: React.MouseEvent) => void;
  context: (item: Item, event: React.MouseEvent) => void;
};
type Props = {
  item: Item;
  selected: boolean;
  accent: string;
  scale: number;
  editing: boolean;
  events: RefObject<ItemEvents>;
};

// The camera can move without changing an item's appearance. Event dispatch
// reads the latest canvas state, so memoization never freezes tool or selection
// behavior. Selected rings and crossings of the detail threshold still redraw.
export const CanvasItem = memo(
  function CanvasItem({ events, ...props }: Props) {
    return (
      <ItemView
        {...props}
        onPointerDown={(event) => events.current.down(props.item, event)}
        onDoubleClick={(event) => events.current.double(props.item, event)}
        onContextMenu={(event) => events.current.context(props.item, event)}
      />
    );
  },
  (previous, next) =>
    previous.item === next.item &&
    previous.selected === next.selected &&
    previous.accent === next.accent &&
    previous.editing === next.editing &&
    previous.events === next.events &&
    (previous.scale === next.scale ||
      (!next.selected &&
        isLodItem(previous.item, previous.scale, previous.editing) === isLodItem(next.item, next.scale, next.editing))),
);
